import React from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import {
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon
} from '@mui/icons-material';

/**
 * Pagination component for cursor-based pagination
 * Supports previous/next navigation with page tracking
 */
const Pagination = ({
  currentPage = 1,
  hasMore = false,
  onPageChange,
  loading = false,
  itemsPerPage = 20,
  totalItemsOnPage = 0
}) => {
  const hasPrevious = currentPage > 1;

  const handleFirstPage = () => {
    if (!loading && hasPrevious) {
      onPageChange(1);
    }
  };

  const handlePreviousPage = () => {
    if (!loading && hasPrevious) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (!loading && hasMore) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        flexWrap: 'wrap',
        gap: 2
      }}
    >
      {/* Page info */}
      <Typography variant="body2" color="textSecondary">
        Page {currentPage} • Showing {totalItemsOnPage} {totalItemsOnPage === 1 ? 'item' : 'items'}
        {hasMore && ' (more available)'}
      </Typography>

      {/* Navigation buttons */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton
          onClick={handleFirstPage}
          disabled={!hasPrevious || loading}
          size="small"
          title="First page"
        >
          <FirstPageIcon />
        </IconButton>
        
        <Button
          onClick={handlePreviousPage}
          disabled={!hasPrevious || loading}
          startIcon={<NavigateBeforeIcon />}
          size="small"
          variant="outlined"
        >
          Previous
        </Button>

        <Button
          onClick={handleNextPage}
          disabled={!hasMore || loading}
          endIcon={<NavigateNextIcon />}
          size="small"
          variant="outlined"
        >
          Next
        </Button>

        {/* Note: "Last page" not available with cursor-based pagination */}
        <IconButton
          disabled
          size="small"
          title="Last page not available with cursor-based pagination"
          sx={{ visibility: 'hidden' }}
        >
          <LastPageIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Pagination;

